import type { ReportFormValues } from "../../../components/common/ReportForm";

export const buildReportFormData = (values: ReportFormValues) => {
  const formData = new FormData();
  formData.append("client", JSON.stringify(values.client));
  formData.append("reportType", values.reportType);
  formData.append("sourceType", values.sourceType);
  if (values.sourceType === "html") {
    formData.append("title", values.title.trim());
    formData.append("period", values.period.trim());
  }
  if (values.file) formData.append("file", values.file, values.file.name);
  return formData;
};
